import React, { useState, useEffect } from "react";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import { date } from "../../../utils/dateTime";
import groupBy from "lodash/groupBy";
import Header from "../../../components/molecules/Header";
import { useHistory } from "react-router-dom";
import useStyles from "./style";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "../../../components/TabPanel";
import Skeleton from "@material-ui/lab/Skeleton";
import Divider from "@material-ui/core/Divider";
import Digunakan from "../../../assets/icon/digunakan.png";
import Diterima from "../../../assets/icon/diterima.png";

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const SkeletonLoader = () => {
  const classes = useStyles();

  const data = [1, 2, 3, 4, 5];
  return (
    <>
      <div className={classes.contentWrapper}>
        <div className={classes.head}>
          <div
            style={{
              borderRadius: "7px",
              marginBottom: 15,
              marginTop: -10,
              width: "100px",
            }}
          >
            <Skeleton variarn="text" />
          </div>
        </div>
        {data?.map((value) => (
          <>
            <div className={classes.body}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <div className={classes.wrapIcon}>
                  <Skeleton variant="circle" width={35} height={35} />
                </div>
                <div style={{ width: "20%", paddingLeft: "20px" }}>
                  <Skeleton variarn="text" />
                  <Skeleton variarn="text" />
                </div>
              </div>
            </div>
            <Divider />
          </>
        ))}
      </div>
    </>
  );
};

function Riwayat({ value, data, loading }) {
  const classes = useStyles();

  const groupDataByDate = groupBy(data, (item) => {
    return date(item.createDate);
  });

  const sections = Object.entries(groupDataByDate).map(([key, value]) => {
    return {
      title: key,
      data: value,
    };
  });
  return (
    <TabPanel value={value} index="recent">
      {loading ? (
        <SkeletonLoader />
      ) : (
        sections?.map((item) => {
          return (
            <>
              <div className={classes.contentWrapper}>
                <div className={classes.head}>
                  <div
                    style={{
                      backgroundColor: "#DCDCDC",
                      borderRadius: "7px",
                      marginBottom: 15,
                      marginTop: -10,
                    }}
                  >
                    <span className={classes.title}>{item.title}</span>
                  </div>
                </div>
                {item.data.map((value) => (
                  <>
                    <div className={classes.body}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <div className={classes.wrapIcon}>
                          <img className={classes.icon} src={Diterima} />
                        </div>
                        <div style={{ width: "100%" }}>
                          <span className={classes.titleBody}>
                            {value.trxAmount} {value.description}
                          </span>
                          <p className={classes.bodyTitle}>
                            {value.createDate}
                          </p>
                        </div>
                      </div>
                    </div>
                    <Divider />
                  </>
                ))}
              </div>
            </>
          );
        })
      )}
    </TabPanel>
  );
}

function Penggunaan({ value, data, loading }) {
  const classes = useStyles();

  const groupDataByDate = groupBy(data, (item) => {
    return date(item.createDate);
  });

  const sections = Object.entries(groupDataByDate).map(([key, value]) => {
    return {
      title: key,
      data: value,
    };
  });
  return (
    <TabPanel value={value} index="use">
      {loading ? (
        <SkeletonLoader />
      ) : (
        sections?.map((item) => {
          return (
            <>
              <div className={classes.contentWrapper}>
                <div className={classes.head}>
                  <div
                    style={{
                      backgroundColor: "#DCDCDC",
                      borderRadius: "7px",
                      marginBottom: 15,
                      marginTop: -10,
                    }}
                  >
                    <span className={classes.title}>{item.title}</span>
                  </div>
                </div>
                {item.data.map((value) => (
                  <>
                    <div className={classes.body}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <div className={classes.wrapIcon}>
                          <img className={classes.icon} src={Digunakan} />
                        </div>
                        <div style={{ width: "100%" }}>
                          <span className={classes.titleBody}>
                            {value.trxAmount} {value.description}
                          </span>
                          <p className={classes.bodyTitle}>
                            {value.createDate}
                          </p>
                        </div>
                      </div>
                    </div>
                    <Divider />
                  </>
                ))}
              </div>
            </>
          );
        })
      )}
    </TabPanel>
  );
}

function PointRiwayat() {
  const history = useHistory();
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [profile, setProfile] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = useState("recent");
  const [tabs, setTabs] = useState([
    {
      label: "Coin Diterima",
      value: "recent",
    },
    {
      label: "Coin Digunakan",
      value: "use",
    },
  ]);

  const handleChange = (event, value) => {
    setTabValue(value);
  };

  const getData = async () => {
    setLoading(true);

    try {
      const funcHist = await firefunctions.httpsCallable("inpoin-history")();
      const funcProfile = await firefunctions.httpsCallable("inpoin-profile")();
      const diterima = funcHist?.data?.data?.filter((a) => a.action == "add");
      const digunakan = funcHist?.data?.data?.filter((a) => a.action == "min");

      setData({ digunakan, diterima });
      setProfile(funcProfile?.data?.data ?? []);
      setLoading(false);
    } catch (error) {
      if (error) {
        const loginInpoin = async () => {
          try {
            const func = firefunctions.httpsCallable("inpoin-login");
            const data = {};
            await func(data);
          } catch (error) {
            console.log("-loginInpoin", error);
          }
        };
        loginInpoin();
      }
      console.log("-listVoucher", error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Header
        type="with-title"
        title="Riwayat Tokorame Coin"
        onClick={() => history.push("/tokoramecoin")}
      />

      <div className={classes.wrapRiwayat}>
        <Tabs
          variant="fullWidth"
          aria-label="full width tabs example"
          textColor="primary"
          value={tabValue || "about"}
          onChange={handleChange}
          TabIndicatorProps={{
            style: {
              background: "rgb(86,117,211)",
              background:
                "linear-gradient(90deg, rgba(86,117,211,1) 70%, rgba(249,163,61,1) 70%, rgba(249,163,61,1) 90%, rgba(244,84,141,1) 90%)",
            },
          }}
          size="small"
        >
          {tabs.map((tab) => (
            <Tab
              className={classes.tab}
              key={tab.value}
              label={tab.label}
              value={tab.value}
              {...a11yProps(tab.value)}
            />
          ))}
        </Tabs>
        <Riwayat value={tabValue} data={data?.diterima} loading={loading} />
        <Penggunaan value={tabValue} data={data?.digunakan} loaing={loading} />
      </div>
    </>
  );
}

export default PointRiwayat;
